import React from 'react';
import { Linkedin, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="py-10 bg-dark-bg border-t border-dark-border/50" data-id="element-236">
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-237">
        <div data-id="element-238">
          <div className="text-white font-semibold text-sm mb-1" data-id="element-239">
            Michael Parks
          </div>
          <div className="text-slate-500 text-xs tracking-wide" data-id="element-240">
            Enterprise Technology Executive
          </div>
        </div>

        <div className="text-slate-600 text-xs" data-id="element-241">
          © 2025 Michael Parks. All rights reserved.
        </div>

        <div className="flex items-center gap-6" data-id="element-242">
          <a href="https://www.linkedin.com/in/michael-parks" target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-gold transition-colors" aria-label="LinkedIn" data-id="element-243">
            <Linkedin className="w-4 h-4" data-id="element-244" />
          </a>
          <a href="#" className="text-slate-500 hover:text-gold transition-colors" aria-label="Twitter" data-id="element-245">
            <Twitter className="w-4 h-4" data-id="element-246" />
          </a>
          <a href="mailto:mparks1974@gmail.com" className="text-slate-500 hover:text-white transition-colors text-xs tracking-wide uppercase" data-id="element-247">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}